import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import {
    MenuItemModifier,
    MenuItemModifierSetChooseManyData, MenuItemModifierSetChooseOneData,
    ModifiersSetType
} from "../../../../../services/menu/models";
import { useParams } from "react-router-dom";
import {
    BackButton,
    FlexRowSpaceBetween,
    FlexRowStart, FormControl,
    Paper,
    Space,
    Typography
} from "../../../../../common/components/libs";
import NoModifiersInChooseOneSet from "./NoModifiersInChooseOneSet";
import NoModifiersInChooseManySet from "./NoModifiersInChooseManySet";
import EditModifierForm from "./EditModifierForm";
import { Add as AddIcon, Edit as EditIcon } from "@material-ui/icons";
import { Button} from "@material-ui/core";
import noImageForProduct from "../../menuEditor/assets/noImageForProduct.png";
import { FadeInOutVertical } from "../../../../../common/components/Animated";
import {
    localize,
} from "../../../../../common/libs";
import { locale } from "../../../../../common/consts";
import RemoveModifierForm from "./RemoveModifierForm";
import { useTranslation} from "react-i18next";
import { LocalizedString } from "../../../../../services/general/models";
import { ModifiersFormType } from "../../../store/modifiersSets/forms";


const EditModifiersSetPage = () => {
    const {t} = useTranslation(["general", "menu"]);
    const [name, setName] = useState("");
    const [localizedName, setLocalizedName] = useState<LocalizedString>();
    const [type, setType] = useState(ModifiersSetType.ChooseOne);
    const [modifiers, setModifiers] = useState<MenuItemModifier[]>([]);
    const [id, setId] = useState(-1);
    const { modifiersSetsStore, generalStore } = useStores();
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [isRemoveModifierFormOpen, setIsRemoveModifierFormOpen] = useState(false);
    const [current, setCurrent] = useState<MenuItemModifier | undefined>();
    const [currentIndex, setCurrentIndex] = useState<number | undefined>();

    const [isLoaded, setIsLoaded] = useState(false);

    const { constantsStore } = useStores();

    const { modifierId } = useParams();
    const modifiersSet = modifiersSetsStore.getModifiersSetById(parseInt(modifierId));

    useEffect(() => {
        (async () => {
            await modifiersSetsStore.ensureLoaded();
            const modifiersSet = modifiersSetsStore.getModifiersSetById(parseInt(modifierId));
            setName(localize(modifiersSet.data.name) || "");
            setLocalizedName(modifiersSet.data.name || {});
            setType(modifiersSet.data.type);
            setModifiers([...modifiersSet.data.modifiers]);
            setId(modifiersSet.id);
            generalStore.setPageTitle(t("menu:modifiersSet.modifiersSetEditor"));
            setIsLoaded(true)
        })()
    }, [modifierId, modifiersSetsStore.modifiersSets]);

    if (!isLoaded) return null;

    const getSetModifier = (index: number) => (newMenuItemModifier: MenuItemModifier) => {
        const newModifiersList = [...modifiers];
        newModifiersList[index] = newMenuItemModifier;
        setModifiers(newModifiersList);

        //@ts-ignore
        let data: MenuItemModifierSetChooseManyData | MenuItemModifierSetChooseOneData = {
            name: localizedName,
            modifiers: newModifiersList,
            type
        }
        modifiersSetsStore.updateModifiersSet({
            menuItemModifierSetId: id,
            data
        })
    };

    const pushNewModifier = (newMenuItemModifier: MenuItemModifier) => {
        const newModifiersList = [...modifiers, newMenuItemModifier];
        setModifiers(newModifiersList);

        //@ts-ignore
        let data: MenuItemModifierSetChooseManyData | MenuItemModifierSetChooseOneData = {
            name: localizedName,
            modifiers: newModifiersList,
            type
        }
        modifiersSetsStore.updateModifiersSet({
            menuItemModifierSetId: id,
            data
        })
    };

    const getRemoveModifier = (index: number) => () => {
        const newModifiersList = [...modifiers]
        newModifiersList.splice(index, 1);
        setModifiers(newModifiersList);

        //@ts-ignore
        let data: MenuItemModifierSetChooseManyData | MenuItemModifierSetChooseOneData = {
            name: { [locale as string]: name },
            modifiers: newModifiersList,
            type
        }
        modifiersSetsStore.updateModifiersSet({
            menuItemModifierSetId: id,
            data
        })
    };


    const openForm = () => setIsFormOpen(true);
    const closeForm = () => {
        setIsFormOpen(false);
        setCurrent(undefined);
        setCurrentIndex(-1);
    };
    const openRemoveForm = () => setIsRemoveModifierFormOpen(true);
    const closeRemoveForm = () => {
        setIsRemoveModifierFormOpen(false);
        setCurrent(undefined);
        setCurrentIndex(-1);
    };

    const currencyFormatter = constantsStore.getCurrencyFormatter(generalStore.currency.id);

    return (
        <>
            <FadeInOutVertical show={true}>
                <>
                    <BackButton/>
                    <FlexRowSpaceBetween>
                        <FlexRowStart>
                            <div>
                                <Typography variant={"h4"}>
                                    {name}
                                </Typography>
                                <Typography variant='body1'>
                                    {t("menu:modifiersSet.type")} {t(`menu:modifiersSetType.${type}`)}
                                </Typography>
                            </div>

                        </FlexRowStart>
                        <div>
                            <Space size={2}/>
                            <FlexRowStart>

                                <Button color="primary"
                                        onClick={() => {
                                            modifiersSetsStore.forms.showPopupForm(ModifiersFormType.editMenuModifiersSet, modifiersSet)
                                        }}>
                                    <EditIcon fontSize='small'/>
                                    <span
                                        style={{ display: "inline-block", minWidth: 5 }}
                                    />
                                    {t("general:edit")}
                                </Button>
                                <Button color="primary"
                                        onClick={() => {
                                            setCurrent(undefined);
                                            openForm()
                                        }}
                                >
                                    <AddIcon/>
                                    {t("menu:modifiersSet.addOption")}
                                </Button>
                            </FlexRowStart>

                        </div>
                    </FlexRowSpaceBetween>
                    {
                        modifiers.map((item, index) => {
                            const photos = item.data.photosUrls;

                            let imageBlockContent = [];
                            const imgSrc = photos.length > 0 ? photos[0] : noImageForProduct;
                            imageBlockContent.push(
                                <div key="noPhoto">
                                    <img src={imgSrc} alt="" key={imgSrc} style={{
                                        maxWidth: 150,
                                        maxHeight: 150,
                                        borderRadius: 10
                                    }}/>
                                </div>
                            );

                            return <Paper p={5} mt={3} style={{ position: 'relative' }} key={item.data.productId}>
                                <FlexRowStart>
                                    <div style={{ marginRight: 20 }}>
                                        {imageBlockContent}
                                    </div>
                                    <div style={{ flexGrow: 1 }}>
                                        <Typography variant={"h4"} mb={2}>
                                            {localize(item.data.name)}
                                            {
                                                item.data.isInStopList && <span
                                                    style={{
                                                        display: 'inline-block',
                                                        color: "#ff0000",
                                                        marginLeft: 5,
                                                        fontSize: 16,
                                                        fontWeight: 400
                                                    }}
                                                >
                                                        (в стоп-листе)
                                                    </span>
                                            }
                                        </Typography>
                                        <Typography variant={"h6"} mt={5}>
                                            {t("menu:menuEditor.positionDetails")}
                                        </Typography>
                                        <Typography variant={"body1"}>
                                            {t("menu:modifiersSet.price")} {currencyFormatter.toShow(item.data.sellPrice.price)}
                                        </Typography>
                                    </div>
                                </FlexRowStart>
                                <div style={{
                                    textAlign: "right",
                                    position: "absolute",
                                    top: 7,
                                    right: 20
                                }}>
                                    <Button
                                        color="primary"
                                        onClick={() => {
                                            setCurrent(item);
                                            setCurrentIndex(index);
                                            openForm();
                                        }}
                                    >
                                        {t("general:edit")}
                                    </Button>
                                    <Button
                                        size='small'
                                        color="secondary"
                                        onClick={() => {
                                            setCurrent(item);
                                            setCurrentIndex(index);
                                            openRemoveForm();
                                        }}
                                    >
                                        {t("general:delete")}
                                    </Button>
                                </div>
                            </Paper>
                        })
                    }


                    {
                        modifiers.length === 0 && type === ModifiersSetType.ChooseMany &&
                        <NoModifiersInChooseManySet openForm={openForm}/>
                    }
                    {
                        modifiers.length === 0 && type === ModifiersSetType.ChooseOne &&
                        <NoModifiersInChooseOneSet openForm={openForm}/>
                    }
                </>
            </FadeInOutVertical>
            <EditModifierForm
                open={isFormOpen}
                current={current}
                updateModifier={getSetModifier(currentIndex)}
                pushNewModifier={pushNewModifier}
                handleDone={closeForm}
            />
            <RemoveModifierForm
                open={isRemoveModifierFormOpen}
                current={current}
                removeModifier={getRemoveModifier(currentIndex)}
                handleDone={closeRemoveForm}
            />
        </>
    );

};

export default observer(EditModifiersSetPage);
